import cx from 'clsx';
import React from 'react';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import style from './style.module.scss';

const SensorsAssociatedSkeleton = () =>
  [...Array(6)].map((_, index) => (
    <tr key={index}>
      <td>{index + 1}</td>
      {[...Array(4)].map((_) => (
        <td>
          <SkeletonBlock className={style.skeletonText} />
        </td>
      ))}
    </tr>
  ));

export default SensorsAssociatedSkeleton;
